import type { Channel } from '../../../../common/types'

export function isLinkedInProfile(channel: Channel): boolean {
  return channel.service === 'linkedin' && channel.type === 'profile'
}
